<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Foreword</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em;">DEXTER SAVAGE</span> and Finn Callahan have been enemies for as long as they can remember. They played beach volleyball for the same team in college, and it was hate at first sight.</p>
<p class="P_Normal">Now on the pro-beach volleyball circuit, Dex lives in the shadow of the unbeatable Finn Callahan and his partner Tristan Galliano. To top it off, Finn is as surly and rude as ever and doesn’t bother to hide his disdain for Dex.</p>
<p class="P_Normal">When Dex’s teammate suffers an injury, his coach suggests Finn as a replacement. Can Dex convince Finn to work with his nemesis? Or will working together bring out feelings neither of them expected to find?</p>
<p class="P_Normal">***This book contains hot, sweaty beach volleyball players, lots of shirtless scenes, and men too stubborn to see the truth.***</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?7fe08c83